import { Link } from "react-router-dom";

import { GUIDE, GUIDE_GROUPS } from "../content/guide";

/**
 * The guide's front door: every section, grouped, each with its one-line
 * promise — so the reader picks a destination instead of scrolling for one.
 *
 * Returns:
 *     The guide's index.
 */
export function DocsIndexPage(): JSX.Element {
  return (
    <>
      <header className="docs-head">
        <span className="eyebrow">Guide</span>
        <h1 className="docs-head__title">How the console works</h1>
        <p className="docs-head__lead">
          Everything a researcher needs, written to be done rather than
          read: each section is a short tutorial with the exact commands.
          Start at the top on your first day; come back by section
          afterwards.
        </p>
      </header>

      {GUIDE_GROUPS.map((group) => {
        // An id with a space in it labels nothing; the display string stays.
        const slug = group.toLowerCase().replace(/\s+/g, "-");
        return (
        <section
          key={group}
          className="docs-toc"
          aria-labelledby={`toc-${slug}`}
        >
          <h2 className="eyebrow docs-toc__group" id={`toc-${slug}`}>
            {group}
          </h2>
          <ul className="docs-toc__list">
            {GUIDE.filter((section) => section.group === group).map(
              (section) => (
                <li key={section.id}>
                  <Link
                    to={`/docs/${section.id}`}
                    className="docs-toc__card"
                  >
                    <span className="docs-toc__card-title">
                      {section.title}
                    </span>
                    <span className="docs-toc__card-lead">
                      {section.lead}
                    </span>
                  </Link>
                </li>
              ),
            )}
          </ul>
        </section>
        );
      })}
    </>
  );
}
